/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_SelectionInputs */

const en_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language Selection`)
};

const fr_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection de la langue`)
};

const de_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachauswahl`)
};

const it_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione della lingua`)
};

const ru_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор языка`)
};

const es_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de idioma`)
};

const zh_cn2_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言选择`)
};

const ja_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語の選択`)
};

const hi_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा चयन`)
};

const pt_pt2_language_selection = /** @type {(inputs: Language_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de idioma`)
};

/**
* | output |
* | --- |
* | "Language Selection" |
*
* @param {Language_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const language_selection = /** @type {((inputs?: Language_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_language_selection(inputs)
	if (locale === "de") return de_language_selection(inputs)
	if (locale === "it") return it_language_selection(inputs)
	if (locale === "ru") return ru_language_selection(inputs)
	if (locale === "es") return es_language_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_language_selection(inputs)
	if (locale === "ja") return ja_language_selection(inputs)
	if (locale === "hi") return hi_language_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_language_selection(inputs)
	return en_language_selection(inputs)
});